export const PROSPECT_REASSIGNMENTS = `
  query prospectReassignments($tenant_id: Int!, $filter: ProspectReassignmentFilterInput) {
    prospectReassignments(tenant_id: $tenant_id, filter: $filter) {
      __typename
      ... on ProspectReassignment {
        id
        prospect_id
        requester_chair_id
        owner_chair_id
        staff_approver_id
        reason
        rejection_reason
        status
        chair_approved_at
        staff_approved_at
        rejected_at
        rejected_by_role
        its
        uts
        prospect {
          id
          contact_id
          chair_id
          contact {
            id
            firstname
            lastname
            email
            company {
              id
              name
            }
          }
        }
        requester_chair {
          id
          contact {
            id
            firstname
            lastname
            email
          }
        }
        owner_chair {
          id
          contact {
            id
            firstname
            lastname
            email
          }
        }
        staff_approver {
          id
          contact {
            id
            firstname
            lastname
            email
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
